/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 21V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 8L16 3M21 8L16 13M21 8H9.4C7.15979 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V14.5V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M21 8L16 3M21 8L16 13M21 8C17.6005 8 13.3884 8 9.39961 8C7.15966 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M21 8L16 3M21 8L16 13M21 8C17.6005 8 13.3884 8 9.39961 8C7.15966 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 3L21 8C17.6005 8 13.3884 8 9.39961 8C7.15966 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V21M16 13L18.5 10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 8L16 3M21 8L16 13M21 8C17.6005 8 13.3884 8 9.39961 8C7.15966 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M21 8L16 3M21 8L16 13M21 8C17.6005 8 13.3884 8 9.39961 8C7.15966 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
